import { Collapse } from 'antd';
import { AppTable } from 'shared/UI/UIKit/Table';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { useConstraintsTable } from '../model';
import styles from '../../../styles.module.scss';

export const ConstraintsTable = () => {
  const { columns, tableData } = useConstraintsTable();
  return (
    <AppFlex className={styles.constraintsCollapseContainer}>
      <Collapse ghost className={styles.constraintsCollapse}>
        <Collapse.Panel
          key="sanpin"
          className={styles.constraintsCollapsePanel}
          header={<span className={styles.constraintsCollapseTitle}>СанПиН</span>}
        >
          <AppTable
            dataSource={tableData}
            columns={columns}
            rowKey={(record) => record.code}
            bordered={false}
            showHeader={false}
            className={styles.constraintsTable}
          />
        </Collapse.Panel>
      </Collapse>
    </AppFlex>
  );
};
